import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pqr',
  templateUrl: './pqr.component.html',
  styleUrls: ['./pqr.component.scss']
})
export class PqrComponent implements OnInit {
// toogles
public mostrarLogout: boolean;

// fechas
hoy = new Date();

// propiedades
public identity: any;
public ToggleNombre: any;

// Fake
public DataTabla = [
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 },
  { documento: 12345, obligacion: 6789, valor: 1000, fecha_reintegro: this.hoy, factura: 6666, cuenta: 9999999 }
];

  constructor() { }

  ngOnInit() {
  }

}
